import MobileEventStore from '~/client/src/mobile/stores/EventStore/MobileEvents.store'
import MobileRootStore from '~/client/src/mobile/stores/MobileRoot.store'
import BaseNotification from '~/client/src/shared/models/Notification'
import * as e from '~/client/src/shared/stores/EventStore/eventConstants'
import { isDeliveryType } from '~/client/src/shared/types/NotificationTypes'

export default function (
  eventsStore: MobileEventStore,
  rootStore: MobileRootStore,
) {
  eventsStore.on(e.HANDLE_SAME_PROJECT_SELECTION, () => {
    return {
      dispatch: [e.DISPLAY_DEFAULT_MOBILE_PAGE, true],
    }
  })

  eventsStore.on(e.CHANGE_DELIVERY_STATUS_SUCCESS, state => {
    state.resetToDefaultCompactDeliveryView()
  })

  eventsStore.on(
    e.VIEW_NOTIFICATION,
    (state, notification: BaseNotification) => {
      if (isDeliveryType(notification.type)) {
        const delivery = rootStore.deliveriesStore.byId.get(
          notification.entityId,
        )
        rootStore.deliveryDetailsStore.setViewMode(delivery)
      }

      rootStore.common.displayNotificationDetails(notification)
      return {
        dispatch: [e.MARK_NOTIFICATION_AS_READ, notification],
      }
    },
  )

  eventsStore.on(e.RESET_ALL_FILTERS, () => {
    // only desktop event handler
    return
  })
}
